import { get } from 'lodash'

export default (data, key = 'name', separator = ', ', defaultValue = '') => {
  if (!Array.isArray(data)) {
    return ''
  }
  if (data.length < 1) {
    return defaultValue
  }

  return data.reduce(function (acc, item) {
    const value = get(item, key, '')

    if (acc === null) {
      return value
    }
    return acc + separator + value
  }, null)
}



// WEBPACK FOOTER //
// ./src/helpers/reduce-with-separator.js